import { useMemo } from 'react';
import { useAppSelector } from '@store';

export const usePolicyLinks = () => {
    const {
        settings: { other_settings, domain_settings },
    } = useAppSelector((state) => state.domain);

    return useMemo(
        () => ({
            termsLink:
                other_settings.terms_of_service_url ||
                `https://${domain_settings.dash}/policy/terms`,
            privacyLink:
                other_settings.privacy_policy_url ||
                `https://${domain_settings.dash}/policy/privacy`,
        }),
        [
            other_settings.terms_of_service_url,
            other_settings.privacy_policy_url,
            domain_settings.dash,
        ],
    );
};
